// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-panel {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.section-header {
  text-align: center;
  max-width: 750px;
  margin: 0 auto;
}

.section-header h2 {
  font-size: 2rem;
  color: #f8fafc;
  font-weight: 700;
  margin-bottom: 0.6rem;
}

.section-header p {
  color: #94a3b8;
  font-size: 1.05rem;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
}

.info-card {
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  transition: border-color 0.2s, transform 0.2s;
}

.info-card:hover {
  border-color: #475569;
  transform: translateY(-2px);
}

.info-card.border-accent {
  border-left: 4px solid #38bdf8;
}

.card-tag {
  align-self: flex-start;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #38bdf8;
  background-color: rgba(56, 189, 248, 0.1);
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
}

.info-card h3 {
  font-size: 1.2rem;
  color: #f1f5f9;
  font-weight: 600;
}

.info-card p {
  font-size: 0.95rem;
  color: #94a3b8;
  line-height: 1.6;
}

.care-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.care-list li {
  position: relative;
  padding-left: 1.2rem;
  font-size: 0.93rem;
  color: #cbd5e1;
  line-height: 1.5;
}

.care-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #38bdf8;
  font-weight: bold;
}

.timeline-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

.timeline-card {
  background-color: #1e293b;
  border: 1px solid #334155;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 1.5rem;
}

.timeline-badge {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 700;
  background-color: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

.timeline-card h3 {
  font-size: 1.15rem;
  color: #f8fafc;
  margin-bottom: 0.4rem;
}

.timeline-card p {
  font-size: 0.95rem;
  color: #94a3b8;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/components/Section.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".section-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.section-header {\n  text-align: center;\n  max-width: 750px;\n  margin: 0 auto;\n}\n\n.section-header h2 {\n  font-size: 2rem;\n  color: #f8fafc;\n  font-weight: 700;\n  margin-bottom: 0.6rem;\n}\n\n.section-header p {\n  color: #94a3b8;\n  font-size: 1.05rem;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 1.5rem;\n}\n\n.info-card {\n  background-color: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  transition: border-color 0.2s, transform 0.2s;\n}\n\n.info-card:hover {\n  border-color: #475569;\n  transform: translateY(-2px);\n}\n\n.info-card.border-accent {\n  border-left: 4px solid #38bdf8;\n}\n\n.card-tag {\n  align-self: flex-start;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #38bdf8;\n  background-color: rgba(56, 189, 248, 0.1);\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n}\n\n.info-card h3 {\n  font-size: 1.2rem;\n  color: #f1f5f9;\n  font-weight: 600;\n}\n\n.info-card p {\n  font-size: 0.95rem;\n  color: #94a3b8;\n  line-height: 1.6;\n}\n\n.care-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.care-list li {\n  position: relative;\n  padding-left: 1.2rem;\n  font-size: 0.93rem;\n  color: #cbd5e1;\n  line-height: 1.5;\n}\n\n.care-list li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: #38bdf8;\n  font-weight: bold;\n}\n\n.timeline-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  max-width: 800px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.timeline-card {\n  background-color: #1e293b;\n  border: 1px solid #334155;\n  border-left: 4px solid #f59e0b;\n  border-radius: 10px;\n  padding: 1.5rem;\n}\n\n.timeline-badge {\n  display: inline-block;\n  font-size: 0.8rem;\n  font-weight: 700;\n  background-color: rgba(245, 158, 11, 0.15);\n  color: #fbbf24;\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n  margin-bottom: 0.5rem;\n}\n\n.timeline-card h3 {\n  font-size: 1.15rem;\n  color: #f8fafc;\n  margin-bottom: 0.4rem;\n}\n\n.timeline-card p {\n  font-size: 0.95rem;\n  color: #94a3b8;\n  line-height: 1.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
